import { render } from "./EbppTest.vue?vue&type=template&id=1800abdd&scoped=true"
import script from "./EbppTest.vue?vue&type=script&lang=js"
export * from "./EbppTest.vue?vue&type=script&lang=js"

import "./EbppTest.vue?vue&type=style&index=0&id=1800abdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1800abdd"]])

export default __exports__